/// <reference path="../../setup/_references.ts" />
module nucleus.DynamicWidgetTemplateDirective {
    'use strict';

    export interface IScopeDynamicWidget extends ng.IScope {
        vm: any;
        load: any;
        content: any;
    }
    /* Directive for dynamicaly load widget templates into the dashboard*/
    angular.module('nucleus.DynamicWidgetTemplateDirective', [])
        .directive('dynamicWidgetTemplate', [
            '$compile',
            '$timeout',
            '$templateCache',
            ($compile: ng.ICompileService, $timeout: ng.ITimeoutService, $templateCache: ng.ITemplateCacheService): ng.IDirective => {

                return {
                    restrict: 'A',
                    scope: {
                        load: '=',
                        content: '='
                    },
                    link: (scope: IScopeDynamicWidget, elem: any, attr: ng.IAttributes, ctrl: any) => {
                        var getWidgetTemplate = function(contentType: string) {
                            var template = '';
                            var baseUrl = 'dashboard/widget-templates/';

                            template = $templateCache.get(baseUrl + contentType + '.html');

                            return template;
                        }

                        scope.$watch('load', function(load) {
                            if (load) {
                                elem.html(getWidgetTemplate(elem[0].attributes['content'].value)).show();
                                $compile(elem.contents())(scope);
                            }
                        });
                    }
                }
            }
        ]
    );
}
